import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Auth } from "aws-amplify";

import {
  Button,
  FormControl,
  Spinner,
  FormGroup,
  Toast,
} from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const validAuthStates = ["forgotPassword"];
const validationSchema = Yup.object().shape({
  email: Yup.string().email("*Invalid email").required("*Email Required"),
});

const CustomForgotPassword = ({ authState, onStateChange }) => {
  const [showToast, setShowToast] = useState(false);

  const [sendCodeStatus, setSendCodeStatus] = useState({
    isProcessing: false,
    errorMsg: "",
  });

  useEffect(() => {
    // Reset status of forgot-password form
    setSendCodeStatus({
      isProcessing: false,
      errorMsg: "",
    });
  }, [authState]);

  const toggleToast = () => {
    setShowToast(!showToast);
  };

  const forgotPasswordSubmit = async (values) => {
    try {
      setSendCodeStatus({ isProcessing: true, errorMsg: "" });

      await Auth.forgotPassword(values.email);

      setSendCodeStatus({ isProcessing: false, errorMsg: "" });

      // Go to reset-password form after code was sent successfully
      onStateChange("resetPassword", { email: values.email });
      toggleToast();
    } catch (e) {
      setSendCodeStatus({
        isProcessing: false,
        errorMsg: e.message || "Send code fail. Please try again!",
      });
    }
  };

  const changeToSigninForm = () => {
    onStateChange("signIn");
  };

  return (
    <>
      <Toast show={showToast} onClose={toggleToast} autohide>
        <Toast.Body>Code sent. Please check your inbox!</Toast.Body>
      </Toast>
      {validAuthStates.includes(authState) ? (
        <Formik
          initialValues={{
            email: "",
          }}
          validationSchema={validationSchema}
          onSubmit={forgotPasswordSubmit}
        >
          {({ errors, touched }) => (
            <Form className="auth-form">
              <Field name="email">
                {({ field }) => (
                  <FormGroup controlId="email">
                    <FormControl
                      type="email"
                      placeholder="Email"
                      value={field.value}
                      onChange={field.onChange}
                      className="auth-input"
                      isValid={touched.email && !errors.email}
                      isInvalid={touched.email && errors.email}
                      data-testid="email-forgot-password"
                    />
                    <FormControl.Feedback type="invalid">
                      {errors.email}
                    </FormControl.Feedback>
                  </FormGroup>
                )}
              </Field>

              <div>
                <Button type="submit" disabled={sendCodeStatus.isProcessing}>
                  Send code
                  {sendCodeStatus.isProcessing && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="isProcessing"
                      className="ml-1"
                      aria-hidden="true"
                    />
                  )}
                </Button>
                {sendCodeStatus.errorMsg && (
                  <p className="error-message mt-2 mb-0">
                    {sendCodeStatus.errorMsg}
                  </p>
                )}
                <Button
                  variant="link"
                  className="auth-navigate"
                  onClick={changeToSigninForm}
                  data-testid="login"
                >
                  <em>Login to your account</em>
                </Button>
                {/*
                <p>
                  {`Don't have an account?`}{" "}
                  <Button
                    variant="link"
                    onClick={() => onStateChange("signUp")}
                  >
                    <strong>Sign up</strong>
                  </Button>
                </p>
                */}
              </div>
            </Form>
          )}
        </Formik>
      ) : null}
    </>
  );
};

CustomForgotPassword.propTypes = {
  authState: PropTypes.string,
  onStateChange: PropTypes.func,
};

export default CustomForgotPassword;
